import { useEffect, useRef, useState } from 'preact/hooks';
import { t } from '../i18n/index.js';
import { playSound } from '../audio/sounds.js';
import { formatWhen } from '../views/admin/ClosureAdmin.js';
import { closurePhase, type ArenaClosureView } from '../../shared/protocol.js';

function left(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return m >= 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${m}:${String(s).padStart(2, '0')} min`;
}

/**
 * Advance notice of a maintenance break, shown on every page including the game view
 * (decision 2026-09-27). While new games are blocked a countdown runs; a sound is played when
 * the countdown starts and one minute before the break.
 */
export function ClosureBanner(props: { closure: ArenaClosureView; clockOffset: number }) {
  const [now, setNow] = useState(Date.now() + props.clockOffset);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now() + props.clockOffset), 1000);
    return () => clearInterval(timer);
  }, [props.clockOffset]);

  const c = props.closure;
  const phase = closurePhase(c, now);
  const remaining = c.startsAt === null ? 0 : c.startsAt - now;

  const played = useRef<{ draining: boolean; lastMinute: boolean }>({ draining: false, lastMinute: false });
  useEffect(() => {
    if (phase === 'draining' && !played.current.draining) {
      played.current.draining = true;
      playSound('challenge');
    }
    if (phase === 'draining' && remaining <= 60_000 && !played.current.lastMinute) {
      played.current.lastMinute = true;
      playSound('bankTick');
    }
  }, [phase, remaining]);

  if (phase === 'draining') {
    return (
      <div class="closure-banner draining" role="status">
        🛠 {t.closure.draining(left(remaining), c.message)}
      </div>
    );
  }
  if (phase === 'upcoming') {
    return (
      <div class="closure-banner" role="status">
        🛠 {t.closure.upcoming(formatWhen(c.startsAt!), c.message)}
      </div>
    );
  }
  return null;
}
